/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PurchaseReturnApi } from '../api/purchasereturn.api';
import { switchMap, map } from 'rxjs/operators';
import { PurchaseReturnData, PurchaseReturn } from '../../../interfaces/masters/purchasereturn';

@Injectable()
export class PurchaseReturnService extends PurchaseReturnData {

  constructor(private api: PurchaseReturnApi) {
    super();
  }
searchList(url: string,data:any): Observable<any> {
    
      return this.api.searchList(url,data);
    }
 distinctReason(url: string): Observable<any> {
    return this.api.distinctReason(url);
  }

  list(url: string): Observable<PurchaseReturn[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<PurchaseReturn>{
      return this.api.getById(url);
  }

  create(url: string, data:PurchaseReturn): Observable<PurchaseReturn> {
    return this.api.add(url,data);
  }

  update(url: string, data:PurchaseReturn): Observable<PurchaseReturn> {
    return this.api.update(url,data);
  }
 

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
